var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnvelopeSimple = function SvgIconEnvelopeSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 5.25a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V18a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18zm3.57 1L12 12.143l6.43-5.893zM20 7.523l-7.324 6.714a1 1 0 0 1-1.352 0L4 7.523V17.75h16z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEnvelopeSimple;